module.exports = __webpack_public_path__ + "img/case35-jpg.37347746.jpg";